/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PostApiGreetingsMutationRequest, PostApiGreetingsMutationResponse, PostApiGreetings400, PostApiGreetings401, PostApiGreetings403, PostApiGreetings500 } from "../../types/PostApiGreetings.ts";
import { postApiGreetingsMutationResponseSchema, postApiGreetingsMutationRequestSchema } from "../../zod/GreetingsSchemas/postApiGreetingsSchema.ts";

function getPostApiGreetingsUrl() {
  const res = { method: 'POST', url: `/api/greetings` as const }  
  return res
}

/**
 * @summary Добавление шаблона приветственного экрана
 * {@link /api/greetings}
 */
export async function postApiGreetings({ data }: { data?: PostApiGreetingsMutationRequest }, config: Partial<RequestConfig<PostApiGreetingsMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = postApiGreetingsMutationRequestSchema.parse(data)  
  
  const res = await request<PostApiGreetingsMutationResponse, ResponseErrorConfig<PostApiGreetings400 | PostApiGreetings401 | PostApiGreetings403 | PostApiGreetings500>, PostApiGreetingsMutationRequest>({ method : "POST", url : getPostApiGreetingsUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return postApiGreetingsMutationResponseSchema.parse(res.data)
}